module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border-top": "0.1rem solid #ededed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lastComments"
  }, [_vm._m(0), _vm._v(" "), _c('commentContent', {
    attrs: {
      "items": _vm.lastComments,
      "govImage": _vm.govImage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "last_top"
  }, [_c('div', {
    staticClass: "lastLogo"
  }, [_vm._v("最新评论")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f7a0c84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comments/lastComments.vue
// module id = 293
// module chunks = 1